import { format, parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { IPropertySettings } from '@/modules/settings/property/types';
import IconWithTitleDescription from '@/shared/components/atoms/IconWithTItleDescription';
import { IIconWithTitleDescriptionProps } from '@/shared/components/atoms/IconWithTItleDescription/IconWithTitleDescription';
import PartialListWithTooltip from '@/shared/components/molecules/PartialListWithTooltip';

import Calendar from '~/images/shared/calender.svg';
import Sprout from '~/images/shared/sprout.svg';

const ViewCrop: React.FC<{ field: IPropertySettings.IPropertyField }> = ({
  field,
}) => {
  const { t } = useTranslation();

  const items: IIconWithTitleDescriptionProps[] = [
    {
      icon: <Sprout width='24' height='24' />,
      title: t('crop'),
      description: (
        <PartialListWithTooltip
          limit={2}
          items={[
            {
              description: field.cropName,
              imageURL: field.cropImage,
            },
            ...(field?.varietyName
              ? [
                  {
                    description: field.varietyName,
                  },
                ]
              : []),
          ]}
        />
      ),
      iconAlignment: 'center',
      titleTypography: {
        className: 'text-surface-10',
        weight: 'semiBold',
        variant: 'subtitle2',
      },
      descriptionTypography: {
        weight: 'medium',
      },
    },
    {
      icon: <Calendar width='24' height='24' />,
      title: t('Plantation Date'),
      description: field?.plantationDate
        ? format(parseISO(field.plantationDate), 'MMM d, yyyy')
        : '-',
      iconAlignment: 'center',
      titleTypography: {
        className: 'text-surface-10',
        weight: 'semiBold',
        variant: 'subtitle2',
      },
      descriptionTypography: {
        weight: 'medium',
      },
    },
  ];
  return (
    <div className='grid grid-cols-2 gap-32'>
      {items.map((item, idx) => (
        <IconWithTitleDescription key={`companyBasicInfo${idx}`} item={item} />
      ))}
    </div>
  );
};

export default ViewCrop;
